import React from 'react';
import SubPageTemplate from './SubPageTemplate';

const CommunityPage = () => (
  <SubPageTemplate
    eyebrow="Community"
    title="Stay connected between sessions"
    description="From accountability huddles to monthly town halls, there is always a place to plug in and stay motivated."
    items={[
      { title: 'Neighborhood Huddles', description: 'Weekly small-group standups for progress sharing.' },
      { title: 'Mentor Office Hours', description: 'Open Q&A blocks hosted by senior engineers.' },
      { title: 'Demo Days', description: 'Live-streamed showcases with hiring mentors.' },
      { title: 'Wellness Fridays', description: 'Mindfulness and balance sessions for sustainable growth.' },
    ]}
  />
);

export default CommunityPage;


